import { useCallback, useEffect, useState } from "react";

declare global {
    interface Window {
        fully?: {
            print(): void;
            printHtml(html: string): void;
            getIp4Address(): string;
            getDeviceId(): string;
        };
    }
}

export function useFullyKiosk() {
    const [isFully, setIsFully] = useState(false);

    useEffect(() => {
        // Check if fully interface is available
        if (typeof window !== "undefined" && window.fully) {
            setIsFully(true);
        }
    }, []);

    const printHtml = useCallback((html: string) => {
        if (window.fully && window.fully.printHtml) {
            console.log("Printing via Fully Kiosk API...");
            window.fully.printHtml(html);
            return true;
        }
        return false;
    }, []);

    const print = useCallback(() => {
        if (window.fully && window.fully.print) {
            console.log("Triggering Fully Kiosk print...");
            window.fully.print();
            return true;
        }
        return false;
    }, []);

    return {
        isFully,
        print,
        printHtml,
        fully: typeof window !== "undefined" ? window.fully : undefined,
    };
}
